export const IS_TEST_MODE = typeof jest !== 'undefined';

export const TENANT_ADMIN_PERMISSION = 'User Admin';

export const SSO_REQUIRED_ERR_CODE = 'E061011';
